






import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import UploadDados from '@/model/resource/UploadDados'
import {TipoUpload} from '@/enums/TipoUpload'

@Component({})
export default class UploadStatusButton extends Vue {
  @Prop({type: Object, required: true}) lastUpload!: UploadDados

  get upload() {
    return this.lastUpload
  }

  get buttonText() {
    return this.upload.mensagemErro ?
        this.$t('system.info.importError') : this.$t('system.info.importSuccess')
  }

  get buttonColor() {
    return this.upload.mensagemErro ? 'danger' : 'success'
  }

  showMessage() {
    if (this.upload.mensagemErro) {
      if (this.upload.idTipoUploadFk === TipoUpload.CADASTRO_SLA) {
        this.$snotify.error(this.$t('system.info.importSlaError', {val: this.upload.mensagemErro}) as string)
      } else {
        this.$snotify.error(this.$t('system.info.importDeliveryError', {val: this.upload.mensagemErro}) as string)
      }

    } else {
      if (this.upload.respCargasEmLote) {
        this.$snotify.warning(this.$t('system.info.deliveryIgnored',
            [this.upload.respCargasEmLote.repetidos.length]) as string)
        this.$snotify.success(this.$t('system.info.deliverySuccessfullySaved',
            [this.upload.respCargasEmLote.cadastrados.length]) as string)
      } else if (this.upload.respListLong && this.upload.respListLong.length) {
        this.$snotify.success(this.$t('system.info.deliverySuccessfullySaved',
            [this.upload.respListLong.length]) as string)
      }
    }
  }
}
